import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
`;

export const Content = styled.div`
  flex-grow: 1;
  width: 42rem;
  margin-inline: auto;
  padding-top: 2.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: 1050px) {
    width: 100%;
    padding-inline: 1.6rem;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f9fafb;
`;
